import type { TenantUsersStatusFilter } from '../../features/tenant/tenantUsersListParams';
import type { DirectoryUser } from '../../types/user';

export type StatusFilter = TenantUsersStatusFilter;

export type TenantUser = DirectoryUser & { id: string };

export function formatUserDisplayName(
  user: DirectoryUser,
  unknownUserLabel: string,
): string {
  const fullName = [user.firstName?.trim(), user.lastName?.trim()]
    .filter((part): part is string => Boolean(part))
    .join(' ');

  if (fullName !== '') {
    return fullName;
  }

  const username = user.username?.trim();
  if (username) {
    return username;
  }

  return unknownUserLabel;
}

export function matchesStatusFilter(
  user: TenantUser,
  statusFilter: StatusFilter,
): boolean {
  if (statusFilter === 'all') {
    return true;
  }
  if (user.enabled == null) {
    return false;
  }
  return statusFilter === 'enabled' ? user.enabled : !user.enabled;
}
